import { Auth } from "aws-amplify";
import { useState, useEffect, useCallback } from "react";
import axios from "../axios";

/**
 *
 * @param {*} param0
 * @returns [response, isLoading, error, fetch]
 */
export default function useFetch({
  url: _url,
  method: _method = "GET",
  data: _data = null,
  header: _header = null,
  config: _config = null,
  noAuth: _noAuth = false,
  autoInit: _autoInit = true,
  forceWithouAuth: _forceWithouAuth = false,
}) {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetch = useCallback(
    ({
      url = _url,
      method = _method,
      data = _data,
      header = _header,
      config = _config,
      noAuth = _noAuth,
      forceWithouAuth = _forceWithouAuth,
      onError = () => { },
      onSuccess = () => { },
    }) => {
      setResponse(null);
      setIsLoading(true);
      setError("");
      if ((Auth && Auth.user) || noAuth) {
        const _finalHeader = noAuth
          ? {}
          : {
            Authorization: Auth.user.signInUserSession.idToken.jwtToken,
          };
        let _tempData = data;
        if (!url) {
          console.log("useFetch: URL is undefined");
          setIsLoading(false);
          // setError("URL is undefined");
          return;
        }
        axios({
          method: method,
          url: url,
          headers: {
            ...header,
            ..._finalHeader,
          },
          data: _tempData,
        })
          .then((res) => {
            setResponse(res.data);
            setIsLoading(false);
            onSuccess(res.data);
          })
          .catch((error) => {
            if (
              (error.response && error.response.status === 401) ||
              error.request?.status === 0
            ) {
              try {
                Auth.currentAuthenticatedUser()
                  .then((cognitoUser) => {
                    Auth.currentSession().then((currentSession) => {
                      cognitoUser.refreshSession(
                        currentSession.refreshToken,
                        (err, session) => {
                          try {
                            axios({
                              method: method,
                              url: url,
                              headers: {
                                Authorization: session.idToken.jwtToken,
                              },
                              data: _tempData,
                            })
                              .then((res) => {
                                setResponse(res.data);
                                onSuccess(res.data);
                              })
                              .catch((error) => {
                                if (error.response) setError(error.response);
                                else setError(error);
                                onError(error);
                              })
                              .finally(() => {
                                setIsLoading(false);
                              });
                          } catch (error) {
                            setIsLoading(false);
                          }
                        }
                      );
                    });
                  })
                  .catch((err) => {
                    if (error.response) setError(error.response);
                    else setError(error);
                    setIsLoading(false);
                  });
              } catch (error) {
                if (error.response) setError(error.response);
                else setError(error);
                setIsLoading(false);
              }
            } else {
              if (error.response) setError(error.response);
              else setError(error);
              setIsLoading(false);
              onError(error);
            }
          });
      } else if (forceWithouAuth) {
        const _finalHeader = {};
        let _tempData = data;
        axios({
          method: method,
          url: url,
          headers: {
            ...header,
            ..._finalHeader,
          },
          data: _tempData,
        })
          .then((res) => {
            setResponse(res.data);
            setIsLoading(false);
            onSuccess(res);
          })
          .catch((error) => {
            if (error.response) setError(error.response);
            else setError(error);
            setIsLoading(false);
            onError(error);
          });
      } else {
        console.log("[Error to fetch, Auth.user not found");
      }
    },
    [_url, _method, _data, _header, _config, _noAuth, _forceWithouAuth]
  );

  useEffect(() => {
    if (_autoInit)
      fetch({
        url: _url,
        method: _method,
        data: _data,
        header: _header,
        config: _config,
        noAuth: _noAuth,
        forceWithouAuth: _forceWithouAuth,
      });
  }, [
    _url,
    _method,
    _data,
    _header,
    _config,
    _noAuth,
    _autoInit,
    _forceWithouAuth,
    fetch,
  ]);
  return [response, isLoading, error, fetch];
}
